import { AuthenticationDefinitions } from "./AuthenticationDefinitions";
import AuthenticationDesigner from "./AuthenticationDesigner";

export class Authentication extends AuthenticationDefinitions {
    render() {
        return (
            <div
                data-schema-id={this.props.id}
                className={`fa-draggable fa-Section row ${this.props.designing ? "designing" : ""}`}
                style={{
                    minHeight: this.props.designing ? "300px" : "auto",
                    position: "relative",
                }}
            >
                {this.props.designing ? (
                    <AuthenticationDesigner {...this.props} />
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}
